import React, { Fragment, useEffect, useRef, useState } from "react";
import { StackedCarousel, ResponsiveContainer } from 'react-stacked-center-carousel';
import './main.css'
import mainIntro from "assets/images/service_intro.mp4"
import middleIntro from "assets/images/service_middle_intro.mp4"
import mainSection13 from "assets/images/main_section13.jpg"
import mainSection14 from "assets/images/main_section14.jpg"
import mainSection15 from "assets/images/main_section15.jpg"
import mainSection16 from "assets/images/main_section16.jpg"
import mainSection17 from "assets/images/main_section17.jpg"
import mainSection18 from "assets/images/main_section18.jpg"
import mainSection19 from "assets/images/main_section19.jpg"
import mainSection20 from "assets/images/main_section20.jpg"
import mainSection21 from "assets/images/main_section21.jpg"
import mainSection22 from "assets/images/main_section22.jpg"
import mainSection23 from "assets/images/main_section23.jpg"
import serviceIntroduction from "assets/images/service_introduction.png"
import medal from "assets/images/medal.png"
import leftArrow from "assets/images/svg/carousel_left_arrow.svg"
import rightArrow from "assets/images/svg/carousel_right_arrow.svg"
import carouselShadow from "assets/images/carousel_shadow.png"
import sectionBg from "assets/images/service_section_bg.jpg"
import mockUp1 from "assets/images/service_mockup1.png"
import mockUp2 from "assets/images/service_mockup2.png"
import structure from "assets/images/service_structure.png"

const ServiceIntroduction = () => {
  const videoRef1 = useRef(null)
  const videoRef2 = useRef(null)
  const carouselRef = useRef(null);
  const divRefs = useRef([]);
  const scrollContainerRef = useRef(null)

  const [videoRendered, setVideoRendered] = useState(false)

  useEffect(() => {
    const container = scrollContainerRef.current;
    const target = divRefs.current[6];

    if (container && target) {
      // 타겟 중앙 위치 계산
      const targetCenter = target.offsetLeft + target.offsetWidth / 2;
      const containerCenter = container.clientWidth / 2;

      // 스크롤 위치 설정
      container.scrollLeft = targetCenter - containerCenter;
    }
  }, []);

  useEffect(() => {
    const delayArray = [
      { index: 0, delay: 500 },
      { index: 5, delay: 500 },
    ];

    const getDelay = (idx) => {
      const found = delayArray.find((d) => d.index === idx);
      return found ? found.delay : 0;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = divRefs.current.indexOf(entry.target);
            const delay = getDelay(index);

            setTimeout(() => {
              entry.target.classList.add("ropik-show");
              observer.unobserve(entry.target);
            }, delay);
          }
        });
      },
      { threshold: 0.3 }
    );

    divRefs.current.forEach((div) => {
      if (div) observer.observe(div);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video1 = videoRef1.current;
    const video2 = videoRef2.current;
    if (!video1) return;

    const handlePlay = () => {
      setVideoRendered(true); // 애니메이션 시작
    };

    video1.addEventListener("play", handlePlay);

    video1.play().catch(err => {
      console.warn("Video play failed", err);
    });

    if (!video2) return;

    video2.play().catch(err => {
      console.warn("Video play failed", err);
    });

    return () => {
      video1.removeEventListener("play", handlePlay);
    };
  }, []);

  useEffect(() => {
    const video1 = videoRef1.current;
    const video2 = videoRef2.current;
    if (!video1) return;

    const handleCanPlayThrough = () => {
      setTimeout(() => {
        setVideoRendered(true); // 2초 뒤 애니메이션 시작
      }, 2000);
    };

    video1.addEventListener("canplaythrough", handleCanPlayThrough, { once: true });

    video1.play().catch(err => {
      console.warn("Video play failed", err);
    });

    if (!video2) return;

    video2.play().catch(err => {
      console.warn("Video play failed", err);
    });

    return () => {
      video1.pause();
      video2.pause();
      video1.removeEventListener("canplaythrough", handleCanPlayThrough);
    };
  }, []);

  useEffect(() => {
    // 만약 비디오 재생 안되면 강제재생
    const video1 = videoRef1.current;
    const video2 = videoRef2.current;
    const playVideo = (video) => {
      video.play().catch(err => {
        console.warn("Video play failed", err);
      })
    }
    playVideo(video1)
    playVideo(video2)
  }, [])

  const section1 = [
    {
      title: `스마트 계측 및 데이터 수집`,
      img: mainSection13,
      content: '음식물 쓰레기 배출 현장에서 IoT 기반 폴더형 휴대용 스마트 디바이스를 펼치면 RFID, 센서, 카메라, GPS, LTE 통신 등을 통해 음식물 쓰레기의 실제 배출량을 실시간으로 정확하게 측정합니다.\n측정된 데이터(부피·무게, 사진, 위치 등)는 즉시 플랫폼 서버로 전송되어, 수기로 기록하던 기존 방식의 오류와 분쟁을 원천적으로 차단합니다.'
    },
    {
      title: `실시간 정보 연동 및 업무 자동화`,
      img: mainSection14,
      content: '플랫폼(APP/WEB)은 배출자, 수거업체, 처리장 모두가 실시간으로 음식물 쓰레기 배출·수거·운반·처리 내역을 확인할 수 있도록 지원합니다.\n전자계약, 세금계산서 발행, 수금 관리, 신고관리 등 다양한 행정·정산 업무가 자동화되어 업무 효율성과 투명성이 크게 향상됩니다.\nGPS가 탑재된 차량관제시스템(TMS)으로 수거 차량의 이동 현황을 실시간으로 파악하고, 불법 유통 및 부정행위를 예방할 수 있습니다.'
    },
    {
      title: `통합 플랫폼 네트워크`,
      img: mainSection15,
      content: '전국의 음식물 쓰레기 배출 사업장(약 83만 곳), 수거업체, 처리장 등이 모두 한 플랫폼에 입점하여, 데이터 기반의 투명한 업무 처리가 이루어집니다.\nAPI 연동을 통해 정부의 올바로시스템 등 외부 행정 시스템과도 자동으로 연결되어, 과태료 부과 방지 등 정책적 혜택도 제공합니다.'
    },
    {
      title: `확장성및 ESG·신사업연계`,
      img: mainSection16,
      content: '플랫폼에 축적된 방대한 데이터를 활용해 탄소배출권 사업, 재활용 폐기물·건설자재 폐기물 관리 등 다양한 신사업으로 확장할 수 있습니다.'
    },
  ]

  const section2 = [
    {
      title: `Real-Time Measurement Based on IoT\nIoT기반 실시간 계측`,
      img: mainSection20,
      content: '부피측정센서, RFID, 카메라, GPS, LTE 등 첨단 IoT 기술과 AI 알고리즘을 결합해 음식물류 폐기물의 부피를 현장에서 자동으로 정확하게 측정합니다.'
    },
    {
      title: `Automatic Data Transmission\n데이터 자동 전송`,
      img: mainSection21,
      content: '측정된 데이터(부피, 사진, 위치 등)를 실시간으로 플랫폼 서버에 전송하여, 수기 입력이나 아날로그 방식의 오류와 분쟁을 최소화합니다.'
    },
    {
      title: `Portability and Convenience\n휴대성 및 편의성`,
      img: mainSection22,
      content: '현장 어디서나 쉽게 사용할 수 있는 휴대용 디바이스로 설계되어, 다양한 배출 환경에 유연하게 대응할 수 있습니다.'
    },
    {
      title: `Wireless Charging Support\n무선충전 지원`,
      img: mainSection23,
      content: '충전 크레들에 올려놓기만 하면 별도의 케이블 연결 없이 간편하게 충전이 가능한 무선충전 기능을 탑재했습니다.'
    },
  ]

  const text1 = 'GLOBAL SMART ENVIRONMENT PLATFORM';
  const text2 = '음식물류 폐기물 스마트 수거 & 통합 유통 서비스 “웨이스트버스”';

  const useWordAnimation = (start, text, delay = 100) => {
    const textArray = text.split(' ');
    const [animatedIndices, setAnimatedIndices] = useState([]);

    useEffect(() => {
      if (!start)
        return;

      let index = 0;
      const interval = setInterval(() => {
        setAnimatedIndices((prev) => [...prev, index]);
        index++;
        if (index >= textArray.length) {
          clearInterval(interval);
        }
      }, delay);

      return () => clearInterval(interval);
    }, [start, text]);

    return { textArray, animatedIndices };
  }

  const { textArray: animationTextArray1, animatedIndices: animatedIndices1 } = useWordAnimation(videoRendered, text1);
  const { textArray: animationTextArray2, animatedIndices: animatedIndices2 } = useWordAnimation(videoRendered, text2);

  const slideData = [
    {
      image: mainSection17,
      title: '배출·수거·처리 전 과정의 디지털화',
      description: '배출, 수거, 운반, 처리 등 모든 과정을\n플랫폼에서 실시간 관리, 업무 효율성과\n투명성 향상',
      small: true,
    },
    {
      image: mainSection18,
      title: 'IoT 기반 실시간 배출량 측정',
      description: '스마트 디바이스로 음식물 쓰레기의 실제 배출량을\n정확하게 측정하고, 데이터를 실시간 전송',
      small: false,
    },
    {
      image: mainSection19,
      title: '전자계약 및 행정업무 자동화',
      description: '전자계약, 세금계산서, 수금, 신고 등\n행정·정산 업무 자동 처리, 인력 및 시간\n비용 절감',
      small: true,
    }
  ];

  return (
    <Fragment>
      <section id="sec_2_1" style={{ position: "relative", height: '100vh', width: '100%', overflow: "hidden" }}>
        <video ref={videoRef1} className="video" loop autoPlay muted>
          <source src={mainIntro} type="video/mp4" />
        </video>
        <div className="service-main-text-container">
          <p>
            {animationTextArray1.map((letter, index) => (
              <Fragment key={letter + index}>
                <span
                  className={`${animatedIndices1.includes(index) ? 'text-animated' : 'opacity-0'} service-main-text-1`}>{letter + '\u00A0'}</span>
                {index === 1 && <br />}
              </Fragment>
            ))}
          </p>
          <p style={{ marginTop: 20 }}>
            {animationTextArray2.map((letter, index) => (
              <Fragment key={letter + index}>
                <span
                  className={`${animatedIndices2.includes(index) ? 'text-animated' : 'opacity-0'} service-main-text-2`}>{letter + '\u00A0'}</span>
                {index === 7 && <br />}
              </Fragment>
            ))}
          </p>
        </div>
      </section>
      <div style={{ width: '100%', position: "relative", paddingBottom: 120 }}>
        <div id="sec_2_2" className="inner-container">
          <div ref={(el) => (divRefs.current[0] = el)}>
            <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', marginTop: 120, textAlign: 'center' }}>
              <span className="ropik-text-reveal">플랫폼 (PLATFORM)</span>
            </p>
            <p style={{ marginTop: 20, fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
              <span className="ropik-text-reveal">웨이스트버스 플랫폼은 음식물 쓰레기 관리의 전 과정(배출-수거-처리)을 디지털화하고, 배출자(음식점 등), 수거업체, 처리장 등을</span>
              <span className="ropik-text-reveal">하나의 통합 시스템으로 연결하는 혁신적인 IoT(사물인터넷) 기반 플랫폼입니다.</span>
            </p>
          </div>
          <div style={{ marginTop: 50, width: '100%', display: "flex", justifyContent: 'center', gap: '50px 30px', flexWrap: 'wrap' }}>
            {section1.map((item, index) => (
              <div ref={(el) => (divRefs.current[index + 1] = el)} className={`ropik-fade-up`} key={'service_section1' + index} style={{ width: 580 }}>
                <div style={{ backgroundImage: `url(${item.img})`, width: '100%', height: 304, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
                </div>
                <p style={{ marginTop: 20, fontWeight: '600', lineHeight: '150%', fontSize: 16, color: '#22B5A1' }}>{item.title}</p>
                <p style={{ marginTop: 5, fontSize: 15, lineHeight: '150%', color: '#1F2D3D' }}>
                  {item.content.split('\n').map((line, i) => (
                    <Fragment key={line + i}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="inner-container" ref={(el) => (divRefs.current[5] = el)} id="sec_2_3" style={{ marginTop: 60, padding: '30px 0' }}>
          <p className="ropik-fade-in" style={{ fontWeight: '500', marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>음식물쓰레기의 배출, 수거, 운반, 처리 등 전반적인 과정을 디지털화하고, 자동화 시스템을 제공하여 관련 업계의 업무 효율성 재고하여 기존 아날로그 방식의 비효율을<br />혁신적인 디지털 솔루션으로 경쟁이 아닌 상생할 수 있는 ESG(환경·사회·지배구조) 통합 플랫폼으로 발전하고 있습니다.</p>
        </div>
        <div ref={scrollContainerRef} className="inner-container scroll-container" style={{ marginTop: 120 }}>
          <div ref={(el) => (divRefs.current[6] = el)} className="ropik-fade-in" style={{ width: 1200, height: 472, backgroundImage: `url(${serviceIntroduction})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        </div>
        <div id="sec_2_4" className="inner-container" style={{ marginTop: 120 }}>
          <div ref={(el) => (divRefs.current[7] = el)}>
            <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
              <span className="ropik-text-reveal">시스템 차별성</span>
            </p>
            <p style={{ fontWeight: '600', marginTop: 20, fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
              <span className="ropik-text-reveal">배출자가 플랫폼에 입점하고자 하면 수집운반업체, 처리장업체는 입점할 수밖에 없는 사업 형태로 각 업체가 홍보하지 않아도</span>
              <span className="ropik-text-reveal">입점만 하면 영업이 이뤄지는 비즈니스 모델, <span style={{ color: '#22B5A1' }}>배출자에게는 “비용절감”</span>을, <span style={{ color: '#22B5A1' }}>수집운반업체는 “고객모집”</span>을 <span style={{ color: '#22B5A1' }}>처리장에는 “물량확보”</span>를 제공하는</span>
              <span className="ropik-text-reveal">차별화된 경쟁력을 갖추고 있습니다.</span>
            </p>
          </div>
          <div ref={(el) => (divRefs.current[8] = el)} className="ropik-fade-up scroll-container" style={{ width: '100%', marginTop: 50 }}>
            <table style={{ width: 1200 }}>
              <tbody>
                <tr style={{ borderWidth: '1px 0px 1px 0px', borderStyle: 'solid', borderColor: '#8491A7', height: 49, textAlign: "center", fontWeight: '600', fontSize: 14, lineHeight: '150%', color: '#1F2D3D' }}>
                  <td colSpan={2}>구분</td>
                  <td>기존업체</td>
                  <td>웨이스트버스</td>
                  <td>차별성</td>
                </tr>
                <tr>
                  <td rowSpan={4} style={{ borderWidth: '0px 1px 0px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>디바이스</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>IoT 스마트 계측기</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>음식물 쓰레기 부피를 대략 눈으로 보고 수기로 입<br />력하는 아날로그 방식</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <img style={{ width: 28, height: 29 }} src={medal} />
                      <p>IoT 계측기로 음식물 쓰레기 배출량을 자동 측정하고, <br />관련 정보(사진, 위치 등)를 실시간으로 전송하는 시스템</p>
                    </div>
                  </td>
                  <td rowSpan={4} style={{ borderWidth: '0px 0px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 15, lineHeight: '150%', textAlign: 'center', fontWeight: '600', color: '#22B5A1', backgroundColor: '#EDFFFD' }}>
                    투명성, 신뢰성<br />제고 및 분쟁 해소
                  </td>
                </tr>
                <tr>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>RFID</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>미지원</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <img style={{ width: 28, height: 29 }} src={medal} />
                      <p>수거통을 통한 배출자<br />(사업자정보, 수거통 용량, 위치 등) 정보 확인</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>카메라</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>미지원</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}></td>
                </tr>
                <tr style={{ borderBottom: '1px solid #8491A7' }}>
                  <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>GPS(차량관제시스템)</td>
                  <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>별도 장착(없음)</td>
                  <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <img style={{ width: 28, height: 29 }} src={medal} />
                      <p>실시간 차량이동현황 및 수거통 위치 파악 가능</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={3} style={{ borderWidth: '0px 1px 0px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>전산행정 자동화<br />시스템</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>영업/계약/홍보</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>직접 방문</td>
                  <td rowSpan={3} style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <img style={{ width: 28, height: 29 }} src={medal} />
                      <p>제반 영업, 계약, 마케팅, 정산, 수금, 의무신고 등<br />행정 업무를 플랫폼에서 자동화 지원</p>
                    </div>
                  </td>
                  <td rowSpan={3} style={{ borderWidth: '0px 0px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 15, lineHeight: '150%', textAlign: 'center', fontWeight: '600', color: '#22B5A1', backgroundColor: '#EDFFFD' }}>
                    비용절감<br />및 효율성 제고
                  </td>
                </tr>
                <tr>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>정산업무</td>
                  <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>별도의 정산프로그램에 수기 입력하는 방식</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #8491A7' }}>
                  <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>수금/미수금</td>
                  <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>CMS/직접 방문</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="sec_2_8" style={{ marginTop: 120 }}>
            <div ref={(el) => (divRefs.current[9] = el)}>
              <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
                <span className="ropik-text-reveal">비즈니스 차별성</span>
              </p>
              <p style={{ fontWeight: '600', marginTop: 20, fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
                <span className="ropik-text-reveal">각 주체 별로 비용 절감, 업무 효율화, 매출 증대 등 실질적 이익이 돌아가도록 설계되어, 단순 중개가 아닌</span>
                <span className="ropik-text-reveal">‘함께 성장하는 상생 생태계’를 구축합니다.</span>
              </p>
            </div>
            <div ref={(el) => (divRefs.current[10] = el)} className="ropik-fade-up scroll-container" style={{ width: '100%', marginTop: 50 }}>
              <table style={{ width: '100%', whiteSpace: "nowrap" }}>
                <tbody>
                  <tr style={{ borderWidth: '1px 0px 1px 0px', borderStyle: 'solid', borderColor: '#8491A7', height: 49, textAlign: "center", fontWeight: '600', fontSize: 14, lineHeight: '150%', color: '#1F2D3D' }}>
                    <td>구분</td>
                    <td>기존업체</td>
                    <td>웨이스트버스</td>
                    <td>차별성</td>
                  </tr>
                  <tr>
                    <td style={{ borderWidth: '0px 1px 1px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>상생플랫폼</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>5인 이하의 소규모 단일사업자로 타 사업자와 경쟁하는 형태</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <img style={{ width: 28, height: 29 }} src={medal} />
                        <p>플랫폼 입점형으로 배출자, 수거업체, 처리장 모두 경쟁이 아닌<br />상생하는 플랫폼 비즈니스</p>
                      </div>
                    </td>
                    <td rowSpan={5} style={{ borderWidth: '0px 0px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 15, lineHeight: '150%', textAlign: 'center', fontWeight: '600', color: '#22B5A1', backgroundColor: '#EDFFFD' }}>
                      경쟁이 아닌 상생
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderWidth: '0px 1px 1px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>영업 범위 및 네트워크</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>해당 사업장 지역 위주로 서비스 범위가 한정되어 있음</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <img style={{ width: 28, height: 29 }} src={medal} />
                        <p>지역 제한 없이 전국 어디서나 동일한 표준 서비스와 데이터 기반 관리가<br />가능해, 대형 프랜차이즈·급식·호텔 등 전국 단위 고객사 확보에 유리합니다.</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderWidth: '0px 1px 1px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>사업 확장성</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>동종 타 업체와 경쟁구조에서 단가경쟁으로 인한 출혈경쟁이<br /> 불가피함(동종업체와 경쟁으로 사업확장성에 한계가 있음)</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <img style={{ width: 28, height: 29 }} src={medal} />
                        <p>음식물 쓰레기 수거·유통을 넘어, 향후 재활용 폐기물, 건설자재 폐기물,<br />탄소배출권 등 다양한 폐기물 및 ESG 연계 신사업으로 확장할 수 있는<br />구조입니다.</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderWidth: '0px 1px 1px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>플랫폼 사업자 중심구조</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>개별 사업자</td>
                    <td style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <img style={{ width: 28, height: 29 }} src={medal} />
                        <p>기존 음식물류 폐기물 시장이 개별 수집운반업체나 처리장 중심의 오프라인·아<br />날로그 방식이었다면, 웨이스트버스는 데이터·디지털 기반의 플랫폼 사업자가<br />주도하는 구조로 전환합니다.</p>
                      </div>
                    </td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #8491A7' }}>
                    <td style={{ borderWidth: '0px 1px 0px 0px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>디지털 전환 및 효율성</td>
                    <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%' }}>오프라인·아날로그 방식</td>
                    <td style={{ borderWidth: '0px 1px 0px 1px', borderStyle: 'solid', borderColor: '#EAEAEA', padding: '14px 16px', fontSize: 14, lineHeight: '150%', backgroundColor: '#EDFFFD' }}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <img style={{ width: 28, height: 29 }} src={medal} />
                        <p>IoT 기반 스마트 계측기, 실시간 데이터 연동, 전자계약·자동정산 등 디지털<br />혁신을 통해 기존 아날로그 방식의 비효율과 분쟁을 해소합니다.</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div id="sec_2_5" style={{ marginTop: 120 }}>
            <div ref={(el) => (divRefs.current[11] = el)}>
              <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
                <span className="ropik-text-reveal">주요기능</span>
              </p>
              <p style={{ fontWeight: '600', marginTop: 20, fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
                <span className="ropik-text-reveal">웨이스트버스 플랫폼은 IoT기반 실시간 계측, 전 과정의 디지털화, 데이터 기반 정산과 분쟁 최소화, 전자계약·자동 행정, 실시간 차량관제, 정책 연동,</span>
                <span className="ropik-text-reveal">사업 확장성 등 혁신적 기능을 통해 음식물 쓰레기 관리의 투명성과 효율성을 획기적으로 높이는 통합 솔루션입니다.</span>
              </p>
            </div>

            <div className="carousel-container" style={{ position: 'relative', width: 1060, height: 400, margin: '50px auto' }}>
              <img
                src={leftArrow}
                onClick={() => carouselRef.current?.goBack()}
                style={{
                  cursor: 'pointer',
                  position: 'absolute',
                  left: -70,
                  top: 0,
                  bottom: 0,
                  margin: 'auto 0',
                  zIndex: 10,
                }}
              />
              <ResponsiveContainer
                carouselRef={carouselRef}
                render={(parentWidth, carouselRef) => {
                  return (
                    <StackedCarousel
                      customScales={[1, 0.575, 0]}
                      ref={carouselRef}
                      slideComponent={Slide}
                      slideWidth={700}
                      carouselWidth={1060}
                      data={slideData}
                      maxVisibleSlide={3}
                      transitionTime={400}
                      useGrabCursor
                    />
                  )
                }}
              />
              <img
                src={rightArrow}
                onClick={() => carouselRef.current?.goNext()}
                style={{
                  cursor: 'pointer',
                  position: 'absolute',
                  right: -70,
                  top: 0,
                  bottom: 0,
                  margin: 'auto 0',
                  zIndex: 10,
                }}
              />
            </div>
            <div className="mobile-carousel-container" style={{ width: '100%', margin: '50px auto' }}>
              {slideData.map((item, index) => (
                <div ref={(el) => (divRefs.current[index + 18] = el)} className={`ropik-fade-up`} key={'carousel_content_' + index} style={{ width: '100%', height: 320, backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundPosition: 'center', display: "flex", justifyContent: 'center', alignItems: 'center', position: 'relative' }}
                >
                  <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: '#00000080',
                    zIndex: 1,
                  }} />
                  <div style={{
                    zIndex: 2,
                    color: 'white',
                    textAlign: 'center',
                    padding: 16,
                    width: 204
                  }}>
                    <p style={{ fontWeight: '700', fontSize: 20, lineHeight: '130%' }}>
                      {item.title}
                    </p>
                    <p style={{ fontWeight: '600', fontSize: 20, lineHeight: '130%', marginTop: 6, whiteSpace: 'pre-line' }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <section id="sec_2_9" style={{ position: "relative", height: 'calc(100vh)', width: '100%' }}>
        <video ref={videoRef2} className="video" loop autoPlay muted>
          <source src={middleIntro} type="video/mp4" />
        </video>
        <div className="inner-container" style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, margin: 'auto', height: 'fit-content' }}>
          <p className="service-main-text-1">GLOBAL SMART<br />ENVIRONMENT PLATFORM</p>
          <p className="service-main-text-2" style={{ marginTop: 20 }}>음식물류 폐기물 스마트 수거 & 통합 유통 서비스<br />“웨이스트버스”</p>
        </div>
      </section>
      <div id="sec_2_6" style={{ width: '100%', position: "relative", paddingBottom: 120 }}>
        <div className="inner-container">
          <div ref={(el) => (divRefs.current[12] = el)}>
            <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', marginTop: 120, textAlign: 'center' }}>
              <span className="ropik-text-reveal">디바이스 (DEVICE)</span>
            </p>
            <p style={{ marginTop: 20, fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>
              <span className="ropik-text-reveal">"웨이스트버스"는 전세계 최초로 배출량 실측이 가능한 스마트 계측 디바이스와 IoT 플랫폼을 결합하여, 음식물쓰레기 배출부터</span>
              <span className="ropik-text-reveal">수거, 처리, 정산, 행정까지 전과정을 자동화·디지털화 하였습니다.</span>
            </p>
          </div>
          <div style={{ marginTop: 50, width: '100%', display: "flex", justifyContent: 'center', gap: '50px 30px', flexWrap: 'wrap' }}>
            {section2.map((item, index) => (
              <div ref={(el) => (divRefs.current[index + 13] = el)} className={`ropik-fade-up`} key={'service_section2' + index} style={{ width: 580 }}>
                <div style={{ backgroundImage: `url(${item.img})`, width: '100%', height: 304, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }}>
                </div>
                <p style={{ marginTop: 20, fontWeight: '600', lineHeight: '150%', fontSize: 16, color: '#22B5A1' }}>
                  {item.title.split('\n').map((line, i) => (
                    <Fragment key={line + i}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </p>
                <p style={{ marginTop: 5, fontSize: 15, lineHeight: '150%', color: '#1F2D3D' }}>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="inner-container" ref={(el) => (divRefs.current[17] = el)} style={{ marginTop: 60, padding: '30px 0' }}>
          <p className="ropik-fade-in" style={{ fontWeight: '500', marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>스마트계측기는 음식물 쓰레기 관리의 투명성과 효율성을 혁신적으로 높이는 웨이스트버스 플랫폼의 핵심 기술입니다.</p>
        </div>
      </div>
      <div id="sec_2_7" className="mock-up-container" style={{ width: '100%', height: 660, position: "relative", backgroundImage: `url(${sectionBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000033', zIndex: 1 }}></div>
        <div className="inner-container" style={{ height: 497, position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, margin: 'auto', padding: '30px 0', display: "flex", alignItems: "center", zIndex: 2 }}>
          <img style={{ width: 250, height: 497, marginRight: 25 }} src={mockUp1} />
          <img style={{ width: 250, height: 497, marginRight: 47 }} src={mockUp2} />
          <img style={{ width: 630, height: 352 }} src={structure} />
        </div>
      </div>
      <div id="sec_2_7" className="mock-up-container-mobile" style={{ width: '100%', height: 'auto', position: "relative", backgroundImage: `url(${sectionBg})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: 16 }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000033', zIndex: 1 }} />
        <div style={{display: 'flex', justifyContent: "space-between", width: '100%'}}>
          <img style={{ width: '48%', height: 'auto' }} src={mockUp1} />
          <img style={{ width: '48%', height: 'auto' }} src={mockUp2} />
        </div>
        <img style={{ width: '100%', height: 'auto', marginTop: 16 }} src={structure} />
      </div>
    </Fragment>
  )
};

export default ServiceIntroduction


const Slide = ({ data, dataIndex, isCenterSlide }) => {
  const { image, title, description } = data[dataIndex];

  return (
    <div
      style={{
        width: '100%',
        height: 400,
        position: 'relative',
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: '#00000080',
        zIndex: 1,
      }} />
      <div style={{
        zIndex: 2,
        color: 'white',
        textAlign: 'center',
        padding: 16,
      }}>
        <p style={{ fontWeight: '700', fontSize: 30, lineHeight: '130%' }}>
          {title}
        </p>
        <p style={{ fontWeight: '600', fontSize: 20, lineHeight: '130%', marginTop: 6, whiteSpace: 'pre-line' }}>
          {description}
        </p>
      </div>
      {isCenterSlide &&
        <img src={carouselShadow} alt="shadow" style={{
          position: 'absolute',
          bottom: -81,
        }} />
      }
    </div>
  );
};